import L from "leaflet";

/** THE ONE PLACE THE BASEMAP IS CHOSEN.
 *
 *  It was five places. `PositionCard`, `RouteReplay`, `FleetMap`,
 *  `FenceMap` and `GeofenceCard` each carried their own copy of the tile URL
 *  and the attribution, two of them written on the same day as this file --
 *  which is the "check ui/src/lib before hand-building a second copy" failure
 *  CLAUDE.md names, committed while the rule was in front of me.
 *
 *  Centralised because the next change to it is not cosmetic:
 *
 *  ⚠ THE BOUNDARY PROBLEM. Standard OpenStreetMap renders administration ON
 *  THE GROUND, not any country's claim. Verified by fetching tile 6/45/25
 *  (Jammu & Kashmir) and looking at it: Gilgit-Baltistan is labelled in Urdu,
 *  Aksai Chin carries Chinese labels, and the lines drawn are the LoC and the
 *  LAC rather than India's boundary. That is deliberate OSM policy, so NO
 *  OSM-derived style fixes it by itself.
 *
 *  For a product shipping to Indian customers this is a legal exposure, not a
 *  preference: depicting India's boundaries incorrectly is an offence under
 *  Indian law. The fix is a provider whose rendering follows Survey of India
 *  (Mappls/MapmyIndia is the usual answer, and is what the reference product
 *  in this space uses), or self-hosted tiles we style ourselves -- and that
 *  second option means OWNING the boundary, which is a liability to take on
 *  deliberately rather than by default.
 *
 *  Until that decision is made this file keeps the current source, so the
 *  change is one edit here rather than five.
 */

//: PLAIN OSM, BECAUSE WIKIMEDIA 403s EVERY BROWSER.
//:
//: `maps.wikimedia.org/osm-intl` answers "Forbidden: Map tiles are
//: restricted to Wikimedia & affiliated sites only" to any request carrying
//: a Referer -- which every browser sends. Measured both ways against tile
//: 6/45/25: 200 and a valid PNG with no Referer, HTTP 403 with one.
//:
//: SO THE ENGLISH-LABEL DECISION NEVER WORKED IN A BROWSER. D-109 chose
//: osm-intl for exactly that requirement and `FleetMap` has carried it since;
//: it has been silently falling back to plain OSM for every real user the
//: whole time, because FleetMap has a hard-failure fallback and nobody could
//: see the difference between "the chosen source" and "the fallback". The
//: four maps I then centralised onto it had NO fallback and simply went
//: blank, which is the only reason this surfaced at all.
//:
//: A SCRIPT CANNOT TEST THIS. Fetching the tile from a terminal returns 200,
//: so every check short of a browser agrees the source works. That is the
//: same shape as the CARTO failure D-109 records -- HTTP 200 with a 2 KB
//: placeholder where a real tile is 16-31 KB -- and it is the second time a
//: tile provider has failed in a way the obvious test cannot see.
//:
//: ⚠ ENGLISH LABELS ARE THEREFORE UNSOLVED, not solved-elsewhere. Plain OSM
//: renders each place in its local name and BAKES THE TEXT INTO THE IMAGE,
//: so nothing client-side can translate it. Recorded in TECH_DEBT; the fix
//: is the same decision the boundary problem needs, and Mappls would settle
//: both at once.
export const BASEMAP_URL = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
export const BASEMAP_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
export const BASEMAP_MAX_ZOOM = 19;

/** Add the basemap to a map. One call, so no caller can drift. */
export function addBasemap(map: L.Map): L.TileLayer {
  return L.tileLayer(BASEMAP_URL, {
    maxZoom: BASEMAP_MAX_ZOOM,
    attribution: BASEMAP_ATTRIBUTION,
  }).addTo(map);
}
